module.exports = __webpack_public_path__ + "static/media/17.eecb79e6.jpg";